import { render, staticRenderFns } from "./expressList.vue?vue&type=template&id=3c552980&scoped=true"
import script from "./expressList.vue?vue&type=script&lang=js"
export * from "./expressList.vue?vue&type=script&lang=js"
import style0 from "./expressList.vue?vue&type=style&index=0&id=3c552980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c552980",
  null
  
)

export default component.exports